module.exports = " <div class=\"palette-modal stretchy container\" v-bind:class=\"{ open: state.paletteView!=null }\"> <div class=\"stretchy background-cover\" v-on:click=state.closePalette()></div> <div class=\"palette total-center\"> <div class=palette-border> <div class=palette-content> <component :is=state.paletteView></component> <div class=palette-cover></div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Palettes.vue
// module id = 178
// module chunks = 2